var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"far fa-repeat fa-fw mr-1"}),_vm._v(" "+_vm._s(_vm.$t('EVENTS.LABEL.REPEATS_EVERY', { dayOfWeek: _vm.eventRepeatsDayOfWeek, repeatEndDate: _vm.scheduleEndDate, }))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }